import React, { InputHTMLAttributes, ReactNode } from 'react';
import { useMask } from '@react-input/mask';
import InputFrame from '../atoms/InputFrame';

interface MaskEditProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
    label: string;
    errorMessage?: string;
    className?: string;
    labelClassName?: string;
    prefix?: ReactNode;
    mask: string;
    replacement: {
        [key: string]: RegExp;
    };
}

const MaskEdit: React.FC<MaskEditProps> = ({
    prefix,
    label,
    errorMessage,
    className,
    labelClassName,
    mask,
    replacement,
    onChange,
    ...restProps
}) => {

    const inputRef = useMask({
        mask,
        replacement,
    });

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData('text');
        const cleanedText = pastedText.replace(/\D/g, '');
        
        if (onChange && e.target instanceof HTMLInputElement) {
            const target = e.target as HTMLInputElement;
            target.value = cleanedText;
            
            const syntheticEvent = {
                target,
                currentTarget: target,
            } as React.ChangeEvent<HTMLInputElement>;
            
            onChange(syntheticEvent);
        }
    };

    let textColor = "text-gray-900 dark:text-gray-100";
    let focusColor = "focus:border-blue-600 dark:focus:border-blue-400";

    if (errorMessage) {
        textColor = "text-red-700 dark:text-red-400";
        focusColor = "focus:border-red-600 dark:focus:border-red-400";
    }

    return (
        <InputFrame
            label={label}
            errorMessage={errorMessage}
            className={className}
            prefix={prefix}
            textColor={textColor}
            labelClassName={labelClassName}
        >
            <input
                ref={inputRef}
                className={`block py-2.5 px-0 w-full text-sm ${textColor} bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 ${focusColor} peer disabled:opacity-50 disabled:cursor-not-allowed dark:text-white`}
                placeholder=" "
                onChange={onChange}
                onPaste={handlePaste}
                {...restProps}
            />
        </InputFrame>
    );
};

export default MaskEdit;